import React, { useState } from 'react';
import { FileCheck, Shield, TrendingUp, Users, CheckCircle, Archive, ArrowRight, ChevronDown, ChevronUp } from 'lucide-react';

// Import gotowych komponentów
import Stats from '../Stats';
import Trust from '../Trust';
import Newsletter from '../Newsletter';
import ContactForm from '../ContactForm';

// Dodanie importu czcionki Inter
const fontLink = document.createElement('link');
fontLink.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@400;600;700;900&display=swap';
fontLink.rel = 'stylesheet';
document.head.appendChild(fontLink);


const RozliczanieDofinansowan = () => {
  const [activeFaq, setActiveFaq] = useState(null);

  const handleContactClick = () => {
    const contactSection = document.querySelector('#kontakt');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };
  
  const toggleFaq = (index) => {
    setActiveFaq(activeFaq === index ? null : index);
  };

  const faqData = [
      {
          question: "Jakie są najczęstsze błędy przy rozliczaniu dofinansowań?",
          answer: "Do najczęstszych błędów należą: niekwalifikowalność wydatków, brak odpowiedniej dokumentacji księgowej, niezgodność z harmonogramem projektu, czy nieprzestrzeganie zasad promocji projektu. Nasz zespół pomaga ich unikać."
      },
      {
          question: "Czy pomagacie w przypadku kontroli i audytów?",
          answer: "Tak, oferujemy pełne wsparcie i reprezentację podczas kontroli i audytów prowadzonych przez instytucje zarządzające. Przygotowujemy niezbędną dokumentację i doradzamy w kwestiach spornych."
      },
      {
          question: "Co się stanie, jeśli dofinansowanie zostanie nieprawidłowo rozliczone?",
          answer: "Nieprawidłowe rozliczenie może skutkować nałożeniem korekt finansowych, a w skrajnych przypadkach koniecznością zwrotu całości lub części otrzymanych środków wraz z odsetkami. Dlatego tak ważne jest profesjonalne wsparcie."
      }
  ];

  const SectionTitle = ({ children, className = '' }) => (
    <h2 
      className={`text-3xl lg:text-5xl text-white text-center uppercase ${className}`}
      style={{ fontFamily: 'Inter, sans-serif', fontWeight: 900 }}
    >
      {children}
    </h2>
  );

  return (
    <div className="bg-black text-white">
 {/* Hero Section - PRZEBUDOWANA SEKCJA */}
      <section className="relative pt-28 sm:pt-32 pb-16 lg:pt-48 lg:pb-32 overflow-hidden bg-black">
        <div className="absolute inset-0 opacity-10">
          {/* Dekoracyjne, animowane ikony w tle */}
          <div className="absolute top-1/4 left-[15%] animate-float">
            <FileCheck className="w-24 h-24 text-violet-600/40" />
          </div>
          <div className="absolute bottom-1/4 right-[15%] animate-float animation-delay-2000">
            <Shield className="w-32 h-32 text-violet-600/40" />
          </div>
          <div className="absolute top-20 right-[40%] animate-float animation-delay-1000">
            <Archive className="w-20 h-20 text-violet-600/40" />
          </div>
        </div>

        <div className="relative z-10 mx-auto text-center px-6">
            <h1 
              className="text-3xl sm:text-4xl md:text-6xl text-white mb-6 uppercase leading-tight"
              style={{ fontFamily: 'Inter, sans-serif', fontWeight: 900 }}
            >
              Rozliczanie Dofinansowań
            </h1>
            <p className="text-lg sm:text-xl text-gray-200 mb-6 sm:mb-8 font-semibold max-w-3xl mx-auto">
              Zapewniamy Pełne Bezpieczeństwo i Zgodność z Regulacjami
            </p>
            <p className="text-base sm:text-lg text-gray-300 mb-8 sm:mb-10 max-w-3xl mx-auto">
              <strong>Pozyskałeś dofinansowanie? Gratulacje!</strong> Teraz czas na precyzyjne i zgodne z wymogami rozliczenie. Oferujemy kompleksowe wsparcie w zarządzaniu i raportowaniu środków, minimalizując ryzyko nieprawidłowości i zapewniając Ci spokój.
            </p>
            <div className="flex justify-center">
                <button 
                    onClick={handleContactClick} 
                    className="group flex items-center justify-center gap-2 px-6 sm:px-8 py-3.5 sm:py-4 bg-gradient-to-r from-violet-600 to-violet-700 text-white font-semibold rounded-full transition-all duration-300 hover:from-violet-700 hover:to-violet-800 hover:scale-105 text-center"
                >
                    <span>Porozmawiaj o rozliczeniu</span>
                    <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
                </button>
            </div>
        </div>
        <style>{`
          @keyframes float {
              0%, 100% { transform: translateY(0px) rotate(0deg); }
              50% { transform: translateY(-20px) rotate(5deg); }
          }
          .animate-float {
              animation: float 8s ease-in-out infinite;
          }
          .animation-delay-1000 { animation-delay: 1s; }
          .animation-delay-2000 { animation-delay: 2s; }
        `}</style>
      </section>

      <section className="py-16 md:py-24 relative bg-black">
        <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8">
          <SectionTitle className="mb-6">
            Profesjonalne wsparcie w zarządzaniu i rozliczaniu środków
          </SectionTitle>
          <p className="text-lg text-gray-300 text-center mb-16 max-w-3xl mx-auto">
            Błędy w tym obszarze mogą prowadzić do korekt finansowych. Nasz zespół ekspertów zapewnia pełne wsparcie w procesie rozliczania projektów, gwarantując zgodność z przepisami.
          </p>
          <div>
            <h3 className="text-2xl text-white font-bold mb-10 text-center uppercase" style={{ fontFamily: 'Inter, sans-serif', fontWeight: 900 }}>
              Nasze usługi w zakresie rozliczania dofinansowań
            </h3>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              {[
                { title: "Przygotowanie wniosków o płatność", description: "Pomagamy w gromadzeniu dokumentacji, sporządzaniu sprawozdań i wniosków.", icon: <FileCheck className="w-7 h-7" /> },
                { title: "Wsparcie audytowe", description: "Przygotowujemy firmę do kontroli i audytów, reprezentujemy Cię przed instytucjami.", icon: <Shield className="w-7 h-7" /> },
                { title: "Monitorowanie postępu projektu", description: "Wspieramy w bieżącym monitorowaniu realizacji projektu i jego zgodności z założeniami.", icon: <TrendingUp className="w-7 h-7" /> },
                { title: "Kwalifikowalność wydatków", description: "Pomagamy w interpretacji zasad kwalifikowalności, aby uniknąć kosztownych błędów.", icon: <CheckCircle className="w-7 h-7" /> },
                { title: "Zarządzanie zmianami", description: "Doradzamy w przypadku konieczności wprowadzenia zmian w projekcie lub harmonogramie.", icon: <Users className="w-7 h-7" /> },
                { title: "Archiwizacja i okres trwałości", description: "Zapewniamy prawidłowe archiwizowanie dokumentacji i wsparcie w okresie trwałości projektu.", icon: <Archive className="w-7 h-7" /> },
              ].map((service) => (
                <div key={service.title} className="backdrop-blur-md bg-white/5 rounded-xl p-6 border border-white/10 hover:border-violet-600/50 transition-all duration-300">
                  <div className="flex items-start gap-4">
                    <div className="w-14 h-14 bg-gradient-to-br from-violet-600/20 to-violet-700/20 rounded-full flex items-center justify-center flex-shrink-0 text-violet-600">
                      {service.icon}
                    </div>
                    <div>
                      <h4 className="text-lg text-white font-bold mb-2">{service.title}</h4>
                      <p className="text-gray-400 text-sm">{service.description}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 md:py-24 relative bg-black">
        <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8">
          <SectionTitle className="mb-16">Twoje Korzyści ze Współpracy</SectionTitle>
          <div className="grid md:grid-cols-2 gap-8">
            {[
              { title: "Pewność i Bezpieczeństwo", description: "Dzięki naszemu doświadczeniu minimalizujesz ryzyko błędów. Działamy zgodnie z najnowszymi wytycznymi." },
              { title: "Oszczędność Czasu", description: "Przejmujemy na siebie cały ciężar formalności, pozwalając Ci skoncentrować się na rozwoju firmy." },
              { title: "Maksymalizacja Efektów", description: "Dbamy o to, aby proces rozliczenia przebiegł sprawnie, a Ty mógł w pełni wykorzystać przyznane środki." },
              { title: "Indywidualne Podejście", description: "Każdy projekt traktujemy priorytetowo, dostosowując działania do specyfiki Twojej branży." }
            ].map((benefit) => (
              <div key={benefit.title} className="backdrop-blur-md bg-white/5 rounded-xl p-5 sm:p-8 border border-white/10 hover:border-violet-600/50 transition-all duration-300">
                <h3 className="text-xl font-bold text-violet-500 mb-3">{benefit.title}</h3>
                <p className="text-gray-300">{benefit.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Stats />
      <Trust />
      
      <section className="py-16 md:py-24 bg-black">
        <div className="relative z-10 max-w-4xl mx-auto px-6 lg:px-8">
          <SectionTitle className="mb-12">Częste pytania o rozliczanie dotacji</SectionTitle>
          <div className="space-y-4">
            {faqData.map((faq, index) => (
              <div key={index} className="backdrop-blur-md bg-white/5 rounded-xl border border-white/10 overflow-hidden transition-all duration-300 hover:border-violet-600/30">
                <button
                  onClick={() => toggleFaq(index)}
                  className="w-full px-6 py-4 text-left flex justify-between items-center group"
                >
                  <span className="font-semibold text-lg text-white pr-4">{faq.question}</span>
                  {activeFaq === index ? 
                    <ChevronUp className="w-5 h-5 text-violet-600 flex-shrink-0" /> :
                    <ChevronDown className="w-5 h-5 text-gray-400 group-hover:text-violet-600 transition-colors flex-shrink-0" />
                  }
                </button>
                <div className={`transition-all duration-300 ease-in-out ${activeFaq === index ? 'max-h-96' : 'max-h-0'}`}>
                  <div className="overflow-hidden px-6 pb-4">
                    <p className="text-gray-300 pt-2">{faq.answer}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Newsletter />
      <div id="kontakt">
        <ContactForm />
      </div>

      <style>{`
        @keyframes draw { to { stroke-dashoffset: 0; } }
        .animate-draw { stroke-dasharray: 1000; stroke-dashoffset: 1000; animation: draw 3s ease-out forwards; }

        .animated-node {
            position: absolute;
            width: 3.5rem; height: 3.5rem;
            border-radius: 9999px;
            display: flex; align-items: center; justify-content: center;
            background: radial-gradient(circle, rgba(249, 115, 22, 0.15) 0%, rgba(249, 115, 22, 0) 60%);
            border: 1px solid rgba(249, 115, 22, 0.2);
            color: #fb923c; /* text-violet-500 */
            opacity: 0;
            animation: fade-in-node 1s ease-out forwards, pulse-node 4s infinite ease-in-out;
            animation-delay: calc(1s + var(--offset) * 2s);
            offset-path: path("M50 50 Q 250 50, 250 225 T 450 400");
            offset-distance: var(--offset);
        }

        @keyframes fade-in-node { from { transform: scale(0.5); opacity: 0; } to { transform: scale(1); opacity: 1; } }
        @keyframes pulse-node { 0%, 100% { transform: scale(1); } 50% { transform: scale(1.05); } }
        
        .max-h-96 { max-height: 24rem; }
      `}</style>
    </div>
  );
};

export default RozliczanieDofinansowan;
